<!--
  黑金 V2 · 我的订单 / 点单记录
  目录：views/SelfHelp/blackV2
  业务逻辑复用 BlackRecordConsume
-->
<template>
  <div class="bv2-record">
    <section class="bv2-dining">
      <div>
        <span>桌号</span>
        <strong>{{ deskCode.code || "未绑定" }}</strong>
      </div>
      <div>
        <span>人数</span>
        <strong>{{ currentPeople }}人</strong>
      </div>
    </section>

    <section v-if="unpaidItems.length" class="bv2-section">
      <header class="bv2-section-title">
        <h2>待支付</h2>
      </header>

      <article
        v-for="group in timeGroups"
        :key="group.id"
        class="bv2-group"
      >
        <h3>— {{ group.name }} —</h3>
        <div
          v-for="item in group.items"
          :key="getUnpaidItemKey(item)"
          class="bv2-item"
        >
          <img :src="item.PicUrl || placeholderImage" :alt="item.GoodsName" />
          <div>
            <strong>{{ item.GoodsName }}</strong>
            <span>{{ getUnpaidDescription(item) }}</span>
          </div>
          <aside>
            <strong>¥{{ formatMoney(item.Price) }}</strong>
            <span>×{{ item.num }}</span>
          </aside>
        </div>
        <footer>
          <span>{{ group.count }}份餐品 小计：</span>
          <strong>¥{{ formatMoney(group.total) }}</strong>
        </footer>
      </article>
    </section>

    <section class="bv2-section">
      <header class="bv2-section-title"><h2>已支付订单</h2></header>

      <div v-if="loading" class="bv2-state">订单加载中...</div>
      <div v-else-if="loadError" class="bv2-state">
        <p>{{ loadError }}</p>
        <button type="button" @click="loadOrderRecords">重新加载</button>
      </div>
      <div v-else-if="!paidOrders.length" class="bv2-state">暂无订单</div>

      <article
        v-for="order in paidOrders"
        v-else
        :key="order.Id"
        class="bv2-group"
      >
        <h3>— 下单时间：{{ order.CreateTime }} —</h3>
        <div
          v-for="detail in order.Details || []"
          :key="detail.Id || detail.ProductId"
          class="bv2-item"
        >
          <img
            :src="detail.ProductImage || placeholderImage"
            :alt="detail.ProductName"
          />
          <div>
            <strong>{{ detail.ProductName }}</strong>
            <span>{{
              [detail.Specification, detail.Remark].filter(Boolean).join(" · ")
            }}</span>
          </div>
          <aside>
            <strong>¥{{ formatMoney(detail.Price) }}</strong>
            <span>×{{ detail.Quantity }}</span>
          </aside>
        </div>
        <footer>
          <span>{{ getFoodsCount(order.Details) }}份餐品 小计：</span>
          <strong>¥{{ formatMoney(order.OrigMoney) }}</strong>
        </footer>
      </article>
    </section>

    <footer class="bv2-footer">
      <div class="bv2-total">
        <span>共{{ unpaidCount }}份餐品</span>
        <strong>¥{{ formatMoney(unpaidMoney) }}</strong>
      </div>
      <div class="bv2-total bv2-total-paid">
        <span>已支付 共{{ paidTotalCount }}份餐品</span>
        <strong>¥{{ formatMoney(paidTotalMoney) }}</strong>
      </div>
      <button type="button" class="bv2-btn" @click="handleToMicropoint">
        继续加菜
      </button>
      <button
        v-if="unpaidItems.length && pendingPayType === 1"
        type="button"
        :disabled="isPaying"
        class="bv2-btn"
        @click="submitPayment"
      >
        {{ isPaying ? "支付中..." : "立即付款" }}
      </button>
    </footer>
  </div>
</template>

<script>
import BlackRecordConsume from "../BlackRecordConsume.vue";
import { getBlackMicropointRouteName } from "@/utils";

export default {
  name: "BlackRecordConsumeV2",
  extends: BlackRecordConsume,
  methods: {
    handleToMicropoint() {
      this.$router.push({ name: getBlackMicropointRouteName() });
    },
  },
};
</script>

<style lang="scss" scoped>
$bg: #000;
$panel: #1a1a1a;
$gold: #ffc653;
$gold-gradient: linear-gradient(120deg, #e5c15e, #fff0ba 48%, #e9c769);
$text: #fff;
$muted: #8f8f8f;
$soft: #cfcfcf;
$btn-text: #20201e;

.bv2-record {
  min-height: 100vh;
  padding: 28px 24px calc(112px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: $text;
  background: $bg url("~@/assets/black-micropoint/v2-category-icons/bg.png") center top / 100%
    auto no-repeat;
  color-scheme: dark;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.bv2-dining {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;

  > div {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    padding: 0 22px;
    border: 1px solid rgba(255, 198, 83, 0.28);
    border-radius: 8px;
    background: rgba(26, 26, 26, 0.9);
    font-size: 24px;

    strong {
      color: $gold;
      font-size: 26px;
      font-weight: 600;
    }
  }
}

.bv2-section {
  margin-bottom: 28px;
}

.bv2-section-title {
  margin-bottom: 16px;

  h2 {
    margin: 0;
    color: $gold;
    font-size: 30px;
    font-weight: 600;
  }
}

.bv2-group {
  margin-bottom: 16px;
  padding: 20px;
  border-radius: 10px;
  background: $panel;

  h3 {
    margin: 0 0 16px;
    color: $gold;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }

  > footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 14px;
    color: $muted;
    font-size: 22px;

    strong {
      margin-left: 8px;
      color: $gold;
    }
  }
}

.bv2-item {
  display: flex;
  align-items: center;
  min-height: 110px;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  > img {
    width: 96px;
    height: 96px;
    border-radius: 8px;
    object-fit: cover;
  }

  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
    margin-left: 16px;

    strong {
      overflow: hidden;
      font-size: 26px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    span {
      margin-top: 8px;
      overflow: hidden;
      color: $muted;
      font-size: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  aside {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 12px;

    strong {
      color: $gold;
      font-size: 26px;
    }

    span {
      margin-top: 10px;
      color: $soft;
      font-size: 22px;
    }
  }
}

.bv2-state {
  padding: 60px 20px;
  color: $muted;
  text-align: center;
  font-size: 26px;

  button {
    margin-top: 16px;
    padding: 12px 28px;
    border: 0;
    border-radius: 8px;
    color: $btn-text;
    background: $gold;
    font-size: 24px;
  }
}

.bv2-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 16px;
  height: calc(96px + env(safe-area-inset-bottom));
  padding: 0 24px env(safe-area-inset-bottom);
  box-sizing: border-box;
  background: #171817;
}

.bv2-total {
  display: flex;
  flex-direction: column;
  min-width: 0;

  span {
    color: #aaa69f;
    font-size: 17px;
  }

  strong {
    margin-top: 4px;
    color: #f3ce69;
    font-size: 28px;
    line-height: 1;
  }
}

.bv2-total-paid {
  margin-right: auto;
}

.bv2-btn {
  flex: 0 0 190px;
  width: 190px;
  height: 68px;
  padding: 0 24px;
  border: 0;
  border-radius: 10px;
  color: #32394b;
  background: $gold-gradient;
  font-size: 27px;
  font-weight: 600;

  &:disabled {
    color: #777;
    background: #444;
  }
}
</style>
